<p-card class="offshore-report-card pb-20">
  @if (
    offshoreReportStore.fetchingReport() ||
    offshoreReportStore.creatingReport() ||
    portsStore.isFetchingPorts()
  ) {
    <div class="flex h-80 w-full items-center justify-center">
      <nsp-spinner />
    </div>
  } @else {
    @let vm = offshoreReportStore.vm();
    <div class="flex min-h-0 w-full min-w-0 flex-1 overflow-hidden">
      @if (vm.navSections) {
        <nsp-nav-menu
          [showProgress]="true"
          class="sticky z-20 mr-4 min-h-0 shrink-0 overflow-y-hidden"
          [navSections]="vm.navSections"
          (clickedItem)="navigateTo($event)"
        ></nsp-nav-menu>
      }

      <div
        id="main-scroll-container"
        class="flex min-h-0 min-w-0 flex-1 basis-0 flex-col overflow-x-hidden overflow-y-auto"
      >
        <div class="flex min-h-0 min-w-0 flex-1 flex-col gap-y-8 pr-10.5">
          <p
            [ngClass]="{
              invisible: vm.isReportConfigComplete,
            }"
          >
            Please select an event to load report sections.
          </p>

          <re-offshore-operational></re-offshore-operational>
          @if (vm.isSectionVisible('positionAndWeather')) {
            <re-offshore-weather></re-offshore-weather>
          }
          @if (vm.isSectionVisible('consumptions')) {
            <re-offshore-consumptions></re-offshore-consumptions>
          }
          @if (vm.isSectionVisible('bunker')) {
            <re-offshore-bunker></re-offshore-bunker>
          }
          @if (vm.isSectionVisible('stock')) {
            <re-offshore-stock></re-offshore-stock>
          }
        </div>

        @if (offshoreReportStore.vm().isReportConfigComplete) {
          <re-form-actions-footer
            [isDrawerOpen]="showDrawer"
          ></re-form-actions-footer>
        }
      </div>

      @if (showDrawer) {
        <div
          id="padding-for-drawer"
          class="w-79.5 shrink-0"
        ></div>
      }

      @if (offshoreReportStore.vm().isReportConfigComplete) {
        <p-button
          class="fixed top-13.5 z-1029 rounded-l-full text-white shadow-lg"
          [ngClass]="{
            'right-0': !showDrawer,
            'right-79.5 opacity-60': showDrawer,
          }"
          (click)="showDrawer = !showDrawer"
          size="large"
          styleClass="h-[50px] rounded-r-none! "
          ><nsp-icon
            [name]="
              !showDrawer ? IconNames.ChevronLeft : IconNames.ChevronRight
            "
          />
        </p-button>

        <p-drawer
          [(visible)]="showDrawer"
          position="right"
          header="Stock"
          [autoZIndex]="false"
          [showCloseIcon]="false"
          [modal]="false"
          styleClass="mt-[50px] w-80 flex h-[calc(100%-50px)] z-1029"
          class="z-1029"
        >
          <re-drawer-content></re-drawer-content>
        </p-drawer>
      }
    </div>
  }
</p-card>
